export default {
    contextAccount: null,
    accounts: {},
    templateAttributes: [],
    accountVehicleModels: {
        wanted: [],
        exchange: [],
    },
    accountVehicleModelsLoaded: false,
    config: {
        customCategories: [],
        automatableTriggerFields: {},
    },
    contextPdfTemplates: [],
    contextPdfTemplatesLoaded: false,
};
